import { Link } from "react-router-dom";
import { SinhUpSchema } from "../../Schemas/SingUpPage";
import { useFormik } from "formik";
import Spinner from "../../videos/Spinner.gif";
import { useDispatch, useSelector } from "react-redux";
import { smoothScrollToTop } from "../../Utility";
import { Suspense, lazy, useState } from "react";
import { cleanup } from "@testing-library/react";
import { setLoadingBarProgress } from "../../features/LoadingBarSlice";
import { RenderLoadingSpinnerInImageTag } from "../LoggedInComponents/Helper";

// * Redux Actions
import {
  generateEmailLink,
  formSubmittedAgain,
  enableRequestVerificationLinkBtn,
  resendEmailVerificationLinkTimer,
} from "../../features/Api/generateEmailLinkSlice";

// * import method different because its a lazy load import
const Formheader = lazy(() => import("../FormHeader"));
// import Formheader from "../FormHeader";

export default function SingUp() {
  // * Return Component with lazy setup
  function returnComponentWithLazySetup(Component, loadingMsg) {
    return (
      <Suspense
        fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
      >
        {Component}
      </Suspense>
    );
  }
  // * At the top of the page.
  useState(() => {
    const smoothScroll = smoothScrollToTop();
    return cleanup(smoothScroll);
  }, []);

  const dispatch = useDispatch();
  const singUpRequest = useSelector((state) => state.signUp);

  // * Start ***Enable Dark Mode Feature***
  const bgCardDynamic = useSelector((state) => state.setMode).css
    ?.cardBackground;
  const textColorDynamic = useSelector((state) => state.setMode).css?.textColor;
  const textFormAlertLightMode = useSelector((state) => state.setMode).css
    ?.textFormAlertColor;

  // * Increase loading progress bar
  function increaseProgressBar() {
    if (singUpRequest.response !== null) {
      dispatch(setLoadingBarProgress({ progress: 100 }));
    }
    if (singUpRequest.error !== null) {
      dispatch(setLoadingBarProgress({ progress: 100 }));
    }
  }
  increaseProgressBar();
  // * Handel form
  const initialValues = {
    name: "",
    email: "",
    gender: "",
    password: "",
    repeatPassword: "",
  };

  const { values, handleSubmit, handleBlur, handleChange, errors, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: SinhUpSchema,
      onSubmit: (values) => {
        delete values.repeatPassword;
        dispatch(generateEmailLink(values));
        dispatch(setLoadingBarProgress({ progress: 70 }));
        setTimeout(function () {
          // Your code or task to be executed after 1 minute
          dispatch(enableRequestVerificationLinkBtn());
          console.log("One minute has passed!");
        }, 60000); // 60000 milliseconds = 1 minute
        dispatch(resendEmailVerificationLinkTimer());
      },
    });

  // * Request email verification link agin  or Back to Sing up form again
  const againRequestLinkBtnRelatedFun = () => {
    if (singUpRequest?.success) {
      dispatch(generateEmailLink(values));
      dispatch(enableRequestVerificationLinkBtn());
      setTimeout(function () {
        // * Code or task to be executed after 1 minute
        dispatch(enableRequestVerificationLinkBtn());
      }, 60000); // 60000 milliseconds = 1 minute
      dispatch(resendEmailVerificationLinkTimer());
    }
    dispatch(formSubmittedAgain());

    values.email = "";
  };

  return (
    <>
      {/* Sing up form Start*/}
      {singUpRequest?.formSubmitted === false ? (
        <div className="flex min-h-full flex-1 flex-col justify-center px-3 py-12 lg:px-8 mt-16">
          {returnComponentWithLazySetup(
            <Formheader title={"Sing Up in to"} />,
            "Loading form header.."
          )}
          <div
            className={`${bgCardDynamic} mt-2 sm:mx-auto sm:w-full sm:max-w-sm  pb-12 pt-6  px-6 rounded-xl shadow-2xl`}
          >
            <form
              onSubmit={handleSubmit}
              className="space-y-6"
              action="#"
              method="POST"
            >
              {/* Name */}
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm text-Brand-Color  leading-6 font-extrabold"
                >
                  Name
                </label>
                <div className="mt-2">
                  <input
                    id="name"
                    name="name"
                    type="name"
                    autoComplete="name"
                    placeholder="Your Good Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    className="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ffa200d7] outline-none sm:text-sm sm:leading-6"
                  />
                  {errors.name && touched.name ? (
                    <small
                      className={`${textFormAlertLightMode} text-xs font-semibold`}
                    >
                      {errors.name}
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              {/* Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm text-Brand-Color  leading-6 font-extrabold"
                >
                  Email address
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Your Active Email Id"
                    required
                    className="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ffa200d7] outline-none sm:text-sm sm:leading-6"
                  />
                  {errors.email && touched.email ? (
                    <small
                      className={`${textFormAlertLightMode} text-xs font-semibold`}
                    >
                      {errors.email}
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              {/* Gender */}
              <h4 className="mt-6 block text-sm text-Brand-Color  font-extrabold ">
                Gender
              </h4>
              <div className="flex flex-row">
                <div className=" basis-1/3">
                  <div className="flex items-center  ">
                    <input
                      name="gender"
                      type="radio"
                      value="male"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="h-4 w-4 border-gray-300 text-[#ffa200] focus:ring-[#ffa20071]"
                    />
                    <label
                      htmlFor="push-everything"
                      className={`block text-sm leading-3 ms-2 font-semibold ${textColorDynamic}`}
                    >
                      Male
                    </label>
                  </div>
                </div>
                <div className=" basis-1/3">
                  <div className="flex items-center  ">
                    <input
                      name="gender"
                      type="radio"
                      value="female"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="h-4 w-4 border-gray-300 text-[#ffa200] focus:ring-[#ffa20071]"
                    />
                    <label
                      htmlFor="push-everything"
                      className={`block text-sm leading-3 ms-2 font-semibold ${textColorDynamic}`}
                    >
                      Female
                    </label>
                  </div>
                </div>
                <div className=" basis-1/3">
                  <div className="flex items-center  ">
                    <input
                      name="gender"
                      type="radio"
                      value="other"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={`h-4 w-4 border-gray-300 text-[#ffa200]  focus:ring-[#ffa20071]`}
                    />
                    <label
                      htmlFor="push-everything"
                      className={`block text-sm leading-3 ms-2 font-semibold ${textColorDynamic}`}
                    >
                      Other
                    </label>
                  </div>
                  {errors.gender && touched.gender ? (
                    <small
                      className={`${textFormAlertLightMode} text-xs font-semibold`}
                    >
                      {errors.gender}
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              {/* Password */}
              <div>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="password"
                    className="block text-sm text-Brand-Color  leading-6 font-extrabold"
                  >
                    Password
                  </label>
                </div>
                <div className="mt-2">
                  <input
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    placeholder="Password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    className="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ffa200d7] outline-none sm:text-sm sm:leading-6"
                  />
                  {errors.password && touched.password ? (
                    <small
                      className={`${textFormAlertLightMode} text-xs font-semibold`}
                    >
                      {errors.password}
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              {/* Repeat-Password */}
              <div>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="repeatPassword"
                    className="block text-sm text-Brand-Color  font-extrabold"
                  >
                    Repeat Password
                  </label>
                </div>
                <div className="mt-2">
                  <input
                    name="repeatPassword"
                    type="password"
                    placeholder="Repeat Password"
                    value={values.repeatPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    className="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ffa200d7] outline-none sm:text-sm sm:leading-6"
                  />
                  {errors.repeatPassword && touched.repeatPassword ? (
                    <small
                      className={`${textFormAlertLightMode} text-xs font-semibold`}
                    >
                      {errors.repeatPassword}
                    </small>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-Brand-Color hover:bg-Brand-Color-Light  px-3 py-1.5 text-sm  leading-6 text-white font-bold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ffa200e8]"
                >
                  Sing Up
                </button>
              </div>
            </form>

            <p className={`mt-10 text-center text-sm ${textColorDynamic}`}>
              You have an account?{" "}
              <Link
                to="/login"
                className="font-semibold leading-6 ms-2 text-Brand-Color hover:text-Brand-Color-Light"
              >
                Log in Now
              </Link>
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* Sing up form End */}

      {/* Server response Message */}
      {singUpRequest.formSubmitted ? (
        <div className=" h-screen w-screen relative lex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 mt-16">
          <Formheader title={"Processing"} />
          <div
            className={`absolute ${bgCardDynamic} w-[90%] mt-2 mx-auto sm:w-full sm:max-w-sm  pb-12 pt-6  px-6 rounded-xl shadow-2xl transform -translate-x-1/2 -translate-y-1/2  top-1/2 left-1/2 flex flex-col justify-center items-center
            `}
          >
            {/* Spinner Start */}
            {singUpRequest.loading ? (
              <div className="flex flex-col justify-center items-center">
                <img src={Spinner} className=" w-16 h-1/6" alt="Spinner" />
                <h3 className=" text-Brand-Color text-lg font-semibold text-center">
                  Form submitted. Please wait...
                </h3>
              </div>
            ) : (
              <></>
            )}
            {/* Spinner End */}

            {/* Server response start */}
            {singUpRequest?.response !== null ||
            singUpRequest?.error !== null ? (
              <div className="flex flex-col justify-center items-center">
                <h3
                  className={`${
                    singUpRequest?.success ? "text-Brand-Color" : "text-red-300"
                  } text-lg font-semibold text-center`}
                >
                  {singUpRequest.response?.msg || singUpRequest.error}
                </h3>
              </div>
            ) : (
              <></>
            )}
            {/* Server response End */}

            {/* Button start */}
            {singUpRequest.verificationLinkAgainBtn ? (
              <button
                type="submit"
                onClick={() => {
                  againRequestLinkBtnRelatedFun();
                }}
                className="flex w-full justify-center rounded-md bg-Brand-Color hover:bg-Brand-Color-Light  px-3  my-4 py-1.5 text-sm  leading-6 text-white font-bold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ffa200e8]"
              >
                {singUpRequest.success
                  ? "Request email verification link again"
                  : "New Sing up Attempt?"}
              </button>
            ) : (
              <p className=" text-Brand-Color text-xs font-bold my-7">
                {singUpRequest.verificationLinkAgainMsg}
              </p>
            )}

            {/* Button End */}
          </div>
        </div>
      ) : (
        <></>
      )}
      {/* Server response Message */}
    </>
  );
}
